import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import {
  applyPolarityBeforePaint,
  readStoredPolarity,
  resolvePolarity,
  systemPrefersDark,
} from './theme/polarity';
import { loadDeploymentBranding } from './platform/branding/deploymentBrand';
import { cpApplyBranding } from './branding/cpApplyBranding';
import { BASENAME } from './platform/paths';
import { CpAdminApp } from './shell/CpAdminApp';
import './index.css';

// WS-E / D-18 — resolve + apply the persisted polarity class on <html> BEFORE the branding
// fetch and before first paint. Ordered first deliberately: the branding load is async, and
// applying the theme after it flashes the default polarity for the duration of a network
// round-trip.
applyPolarityBeforePaint();

// Load + apply the deployment brand once at boot, before first render. Any error → neutral
// ("Console"). Top-level `await` is fine here (`type: module`, `target: ES2024`).
const brand = await loadDeploymentBranding();
cpApplyBranding(brand, {
  resolved: resolvePolarity(readStoredPolarity(), systemPrefersDark()),
  basePrefix: BASENAME,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CpAdminApp />
  </StrictMode>,
);
